export default __webpack_public_path__ + "static/media/Mahbub resume .d08bb20d.pdf";